export default "__VITE_ASSET__Bmfptz1T__"